// IMOTEpS — Pont entre les pages pathologies cliniques et les chapitres académiques
// Source de vérité unique pour le maillage interne /pathologie/* ↔ /recherche/*

// Pathology slug -> array of chapter ids (research center)
// Several pathologies can map to the same academic chapter and vice-versa
export const PATHOLOGY_TO_CHAPTERS = {
  // Épaule
  "capsulite-retractile": [1],
  "disjonction-acromio-claviculaire": [2],
  "coiffe-rotateurs": [4, 5],
  "tendinopathies-coiffe": [4, 5, 8, 9],
  "calcification-epaule": [9],
  "instabilite-epaule": [6],
  "arthrose-epaule": [7],
  "prothese-epaule": [7],
  "fractures-epaule-clavicule": [2],
  "plexus-brachial": [11],

  // Coude
  "epicondylite": [10, 8, 9],
  "epitrochleite": [10, 8],
  "rupture-biceps-distal": [10],
  "tendinopathies-coude": [10],

  // Poignet / Main / Neuro
  "canal-carpien": [11],
};

// Reverse map for ChapterPage: chapter id -> array of related pathology slugs
export const CHAPTER_TO_PATHOLOGIES = Object.entries(PATHOLOGY_TO_CHAPTERS).reduce(
  (acc, [pathSlug, chapterIds]) => {
    chapterIds.forEach((cid) => {
      if (!acc[cid]) acc[cid] = [];
      if (!acc[cid].includes(pathSlug)) acc[cid].push(pathSlug);
    });
    return acc;
  },
  {}
);

// Chapters surfaced on the /epaule-du-sportif landing page
export const SPORT_SHOULDER_CHAPTERS = [6, 12, 4, 9];
